import React from 'react';
import './meetus1.css';
import Meetusdiv from '../components/common/meetusdiv';
import m1 from '../assets/m1Icon.svg'
import Mainbt from '../components/common/mainbt';
const Meetus1 = () => {
  return (
    <section>
      <div className="container">
        <div className="meets1">
          <Meetusdiv 
          muicon={m1}
          dicovertext='Discover Elite Designers'
          mup='Explore collections from Egypts most prestigious fashion houses and emerging talents'
          />
          <Mainbt mainbt="Next" link="/meetus2" />
        </div>
        
      </div>
    </section>

  );
};

export default Meetus1;